// removed by extract-text-webpack-plugin
module.exports = {"flag":"flag__2pxo6","show":"show__2hNON"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SearchFlag/styles.scss
// module id = 2146
// module chunks = 1